import { useMutation, useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, ConfigLookupResponse, ConfigEntryResponse } from '../types/showcase';

/**
 * C085 중앙 설정 데모(read-only · never-throw) — queue #646 §R646-2.
 * GET .../config/entries — 활성 설정 목록(마스킹) 자동 조회(보조 표) · ★응답은 배열 그대로(래핑 없음).
 * GET .../config/lookup — 사용자가 key+default 입력 → 조회(useMutation).
 */

export function useConfigEntries() {
  return useQuery<ConfigEntryResponse[], ApiError>({
    queryKey: ['common-showcase', 'config', 'entries'],
    queryFn: () => showcaseApi.configEntries(),
    staleTime: 30_000,
  });
}

export function useConfigLookup() {
  return useMutation<ConfigLookupResponse, ApiError, { key: string; defaultValue: string }>({
    mutationFn: ({ key, defaultValue }) => showcaseApi.configLookup(key, defaultValue),
    mutationKey: ['common-showcase', 'config', 'lookup'],
  });
}
